import React from "react";
import "./button.scss";
const Button = ({ children, onClick, variant, className, disabled, type }) => {
  return (
    <button
      type={type}
      className={`Button ${variant} ${className} ${disabled ? "disabled" : ""}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
